<template>
  <div v-if="isUsuarioLogado()">
    <v-navigation-drawer
        id="default-drawer" v-model="drawer"
        :dark="dark" :right="$vuetify.rtl"
        :src="drawerImage ? image : ''" :mini-variant.sync="mini"
        mini-variant-width="80" app width="260">
      <template v-if="drawerImage" #img="props">
        <v-img :key="image" :gradient="gradient" v-bind="props"/>
      </template>
      <div class="px-2">
        <default-drawer-header/>
        <v-divider class="mx-3 mb-2"/>
        <default-list :items="items"/>
      </div>
      <div class="pt-12"/>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {get, sync} from 'vuex-pathify'
import {StatusLoginEnum} from "../../enums/status-login.enum"
import {mapGetters} from "vuex";
import {MapGetters} from "../../store/modules/auth/map-getters.auth";

export default {
  name: 'DefaultDrawer',

  methods: {
    isUsuarioLogado() {
      return (this.meta.title !== 'Login') && ((this.status === StatusLoginEnum.LOGADO) || (localStorage.jwt && localStorage.jwt !== ''));
    }
  },
  components: {
    DefaultDrawerHeader: () => import(
        /* webpackChunkName: "default-drawer-header" */
        './widgets/DrawerHeader'
        ),
    DefaultList: () => import(
        /* webpackChunkName: "default-list" */
        './List'
        ),
  },

  computed: {
    ...mapGetters(MapGetters.NOME_MODULO, [MapGetters.STATUS]),
    meta: get('route/meta'),
    ...get('user', [
      'dark',
      'gradient',
      'image',
    ]),
    ...get('app', [
      'items',
      'version',
    ]),
    ...sync('app', [
      'drawer',
      'drawerImage',
      'mini',
    ]),
  },
}
</script>

<style lang="sass">
#default-drawer
  .v-list-item
    margin-bottom: 8px

  .v-list-item::before,
  .v-list-item::after
    display: none

  .v-list-group__header__prepend-icon,
  .v-list-item__icon
    margin-top: 12px
    margin-bottom: 12px
    margin-left: 4px

  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important
</style>
